import {React, useRef} from "react";
import './contact.css';
import {AiOutlineMail} from 'react-icons/ai';
import {AiOutlineWhatsApp} from 'react-icons/ai';
import emailjs from 'emailjs-com';

function Contact() {

    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_10ve1xb', 'template_h0pcz9w', form.current, '8mJgKdWP4KMilGRz_')
          .then((result) => {
              console.log(result.text);
          }, (error) => {
              console.log(error.text);
          });
      };

    return(
        <section id="contact">
            <h5>Get In Touch</h5>
            <h2>Contact Me</h2>

            <div className="container contact__container">
                <div className="contact__options">
                    <article className="contact__option">
                        <AiOutlineMail className="icon"/> 
                        <h4>Email</h4>
                        <h5>marwanosman505@gmail.com</h5>
                        <a href="mailto:marwanosman505@gmail.com" target='_blank'>send an email</a>
                    </article>
                    <article className="contact__option">
                        <AiOutlineWhatsApp className="icon"/> 
                        <h4>WhatsApp</h4>
                        <h5>+44 7415859388</h5>
                        <a href="https://api.whatsapp.com/send?phone=447415859388" target='_blank'>send an message</a>
                    </article>
                </div>

                <form ref={form} onSubmit={sendEmail}>
                    <input type='text' name="name" placeholder="Your Full Name" required></input>
                    <input type='email' name="email" placeholder="myemail@example.com" required></input>
                    <textarea name="message" rows={7} placeholder="Your Message"></textarea>
                    <button type='submit' className="btn btn-primary">Send</button>
                </form>
            </div>

        </section>
    )
}

export default Contact;